/* eslint-disable
    react/prefer-stateless-function
*/
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
import classNames from 'classnames';
import React from 'react';

interface Props {
  active: boolean;
  className?: string;
  striped: boolean;
  value: number;
  type?: string;
}

class ProgressBar extends React.Component<Props> {
  static defaultProps = {
    active: false,
    striped: false,
  };

  override render(): JSX.Element {
    return (
      <div
        className={classNames(this.props.className, 'progress', {
          'progress-striped': this.props.striped,
          active: this.props.active && this.props.striped, // `active` only has a visual impact if `striped`
        })}
      >
        <div
          role="progressbar"
          className={classNames({
            'progress-bar': true,
            'progress-bar-success': this.props.type === 'success',
            'progress-bar-warning': this.props.type === 'warning',
            'progress-bar-danger': this.props.type === 'danger',
            'progress-bar-onboarding': this.props.type === 'onboarding',
          })}
          style={{
            width: `${this.props.value}%`,
          }}
        />
      </div>
    );
  }
}

export default ProgressBar;
